import React from 'react';
import Stepper from 'react-stepper-horizontal';

class RentAgreementStepper extends React.Component {

    render() {
        return (
            <div className="rent-agreement-stepper">
                <Stepper steps={[{ title: 'Tenure & Amount' }, { title: 'Make Payment' }, { title: 'Property & Parties' },
                { title: 'Biometric' }, { title: 'Download' }]}
                    activeStep={this.props.currentStep || 0} />
            </div>
        )
    }
}

export default RentAgreementStepper;



// WEBPACK FOOTER //
// ./src/app/components/rent-agreement-stepper/index.js